// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2469":"a20e82562ae5fed9","5947":"8f0a7ea55e0e404b"}[chunkId] + ".css";
};